export default "dist/images/block-feature-overlap-shape3.a8e4e8e.png";